import React from "react";
import {
  Input,
  Select,
  Button,
  Space,
  DatePicker,
  Row,
  Col,
  Checkbox,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import moment from "moment";

import AttendenceReportStore from "../store/AttendenceReportStore";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VehicleStore from "../store/VehicleStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import XML from "../assets/images/NewDesign/XML.svg";
import CSV from "../assets/images/NewDesign/CSV.svg";

const { RangePicker } = DatePicker;

dayjs.extend(customParseFormat);

const defaultValue = moment().startOf("day").hour(0).minute(0).second(0);

class AttendanceReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.attendenceReportStore = new AttendenceReportStore();
    this.vehicleStore = new VehicleStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      SelectedSalespersonId: [],
      selectAllSalesPerson: false,

      modalVisible: false,
      column: "",
      filter: "",
      Notcompany: false,
      Notperson: false,
      salesPerson: [],
      Notdate: false,
      showMonthPopup: false,

      selectedColumns: [
        {
          // title: 'Sales Person Name ',
          title: context.translate("_SALES_PERSON_NAME_"),
          dataIndex: "salespersonname",
          key: "salespersonname",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: 'Punch In Time',
          title: context.translate("_PUNCH_IN_TIME_"),
          dataIndex: "punchInTime",
          key: "punchInTime",
          width: 100,
          ellipsis: { showTitle: true },
        },

        {
          // title: 'Punch In Location',
          title: context.translate("_PUNCH_IN_LOCATION_"),
          dataIndex: "inLocation",
          key: "inLocation",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: 'Punch Out Time',
          title: context.translate("_PUNCH_OUT_TIME_"),
          dataIndex: "punchOutTime",
          key: "punchOutTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: 'Punch Out Location',
          title: context.translate("_PUNCH_OUT_LOCATION_"),
          dataIndex: "outLocation",
          key: "outLocation",
          width: 100,
          ellipsis: { showTitle: true },
        },
      ],
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={CSV}
              ></Image>
              {context.translate("_EXPORT_AS_CSV_")}
            </div>
          ),
          key: "csv",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={XML}
              ></Image>
              {context.translate("_EXPORT_AS_XML_")}
            </div>
          ),
          key: "xml",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: () => {},
    };
    this.newColumns = [...this.state.selectedColumns];
  }
  addMonths = (date, months) => {
    var indx = dayjs().month() + -6;

    return dayjs().month(indx);
  };

  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }
  async componentDidMount() {
    this.setState({ pageSize: 50 });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ column: this.state.selectedColumns });
  }

  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ currentPage: 1, companyId: comp?.value });
    await this.setState({
      SelectedSalespersonId: [],
      selectAllSalesPerson: false,
    });
    const data = await this.attendenceReportStore.getSalesPersonExecutive({
      companyId: comp?.value,
    });

    this.setState({ salesPerson: data });
    // this.handleSearch();
  }

  // async onSearch(value) {
  //     console.log(value)
  //     await this.setState({ emailId: value });
  //     this.handleSearch();
  // };

  async handleSearch() {
    this.setState({ Notperson: false });
    await this.attendenceReportStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
    });

    await this.setState({ listUpdated: 1 }); //need to reload data
  }

  onDateTimeChange = (dates) => {
    // console.log(dates);
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };
  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.SelectedSalespersonId.length === 0) {
      this.setState({ Notperson: true });
    } else {
      this.setState({ Notperson: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }
    if (
      this.state.companyId &&
      this.state.SelectedSalespersonId.length > 0 &&
      this.state.fromDate &&
      this.state.toDate
    ) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notperson: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.attendenceReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          salespersonId: this.state.SelectedSalespersonId,
          fromDate: this.state.fromDate,
          toDate: defaultValue.format("YYYY-MM-DD HH:mm:ss"),
        });
        await this.setState({ loadData: 1 });
      } // console.log(this.state.fromDate,this.state.toDate,)
    }
  };
  handleAllSelectSalesPerson = async (e) => {
    if (this.state.selectAllSalesPerson) {
      const allVehicles = this.attendenceReportStore?.salesPersonArray.map(
        (val) => {
          return val.salesPersonId;
        }
      );
      await this.setState({ SelectedSalespersonId: allVehicles });
    } else {
      await this.setState({ SelectedSalespersonId: [] });
    }
  };
  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };

  render() {
    //console.log('in render1')

    return (
      <>
        <div className="listHeader">
          {/* <Row style={{ padding: "10px 0px" }}> */}
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />

                <Checkbox
                  checked={this.state.selectAllSalesPerson}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllSalesPerson: e.target.checked,
                    });
                    console.log(e.target.checked);
                    await this.handleAllSelectSalesPerson();
                  }}
                />

                {this.context.translate("_ALL_")}
                {"  "}

                <Select
                  mode="multiple"
                  className="searchInput"
                  onSearch={this.handleSearch}
                  value={this.state.SelectedSalespersonId}
                  onChange={(val) => {
                    this.setState({
                      SelectedSalespersonId: val,
                      Notperson: false,
                    });
                    if (
                      this.attendenceReportStore?.salesPersonArray.length >
                      val.length
                    ) {
                      this.setState({ selectAllSalesPerson: false });
                    } else {
                      this.setState({ selectAllSalesPerson: true });
                    }
                  }}
                  maxTagCount="responsive"
                  fieldNames={{
                    label: "salesPersonName",
                    value: "salesPersonId",
                  }}
                  // placeholder="Sales Person"
                  placeholder={this.context.translate("_SALES_PERSON_")}
                  optionFilterProp="children"
                  // options={this.attendenceReportStore.salesPersonArray}
                  options={this.state.salesPerson}
                  style={{ width: 150 }}
                  // style={personInputStyle}
                  status={this.state.Notperson ? "error" : false}
                />

                <RangePicker
                  placeholder={["From Datetime", "To Datetime"]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                  status={this.state.Notdate ? "error" : false}
                />

                <Button type="primary" onClick={() => this.showData()}>
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                  {/* Show */}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                {/* <Button
                  className="downloadExcelButton"
                  disabled={
                    this.attendenceReportStore?.attendenceReport?.length > 0 ? false : true
                  }>
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >

                    <Image
                      style={{ height: 18, alignItems: "center", marginInlineEnd: "30px" }}
                      src={downloadIcon}

                    ></Image>

                  </Dropdown>
                </Button> */}
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            key={this.state.selectedColumns.length}
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.attendenceReportStore?.total}
            columns={this.state.selectedColumns}
            dataSource={this.attendenceReportStore?.attendenceReport}
            loading={this.attendenceReportStore?.loading}
            onChange={this.handleTableChange}
            scroll={{
              // y: this.state.clientHeight-240,
              x: 100,
            }}
          />

          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showMonthPopup}
            onOk={() => this.setState({ showMonthPopup: false })}
            onCancel={() => this.setState({ showMonthPopup: false })}
            footer={false}
          >
            {/* For reports prior to 6 months please contact administrator */}
            {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
          </Modal>
        </div>
      </>
    );
  }
}
AttendanceReportList.contextType = StoreContext;
export default observer(withRouter(AttendanceReportList));
